// extracted by mini-css-extract-plugin
export default {"title_wrapper":"Title_title_wrapper__cQaIr","wrapper":"Title_wrapper__xrvce"};